/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const campaignRemoteLookupSchema = z.any();

export const campaignRemoteLookupIdSchema = common.objectId;

export const campaignRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string().nullable(),
  is_draft: z.boolean(),
  is_archived: z.boolean(),
});

export const campaignRemoteLookupFiltersSchema = z.object({});

export const campaignRemoteLookupValidators = {
  id: campaignRemoteLookupIdSchema,
  item: campaignRemoteLookupItemSchema,
  filters: campaignRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 571ecf5a1671b1847be665f47498a540 */
